import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router'
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import store from '../../store'
import { ROUTES } from '../../utils/routes'
import { enqueueErrorSnackbar } from '../../redux/actions/notificationActions'
import { useUser } from '../../utils'
import { Role } from 'common/api/v1/types'
import { ConfirmDialogProvider } from '../common/ConfirmDialog'
import { ContentDialogProvider } from '../common/ContentDialog'
import { mixpanel, usePageTracking } from '../../mixpanel'
import { Loading } from '../common/Loading'

const EventManagerContainer = React.lazy(() => import('./EventManagerContainer'))
const NetworkManagerContainer = React.lazy(() => import('./NetworkManagerContainer'))
const StreamManagerContainer = React.lazy(() => import('./StreamManagerContainer'))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 0,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      store.dispatch(enqueueErrorSnackbar({ error, operation: query.meta?.operation }))
    },
  }),
})

const LoggedIn = () => {
  const user = useUser()
  mixpanel.addUserInfo(user)
  usePageTracking()

  return (
    <QueryClientProvider client={queryClient}>
      <ConfirmDialogProvider>
        <ContentDialogProvider>
          <Suspense fallback={<Loading fullScreen />}>
            <Routes>
              <Route path={`${ROUTES.stream}/*`} element={<StreamManagerContainer />} />
              <Route path={`${ROUTES.events}/*`} element={<EventManagerContainer />} />
              <Route
                path="/*"
                element={
                  user.role === Role.basic ? <Navigate to={ROUTES.stream} replace /> : <NetworkManagerContainer />
                }
              />
            </Routes>
          </Suspense>
        </ContentDialogProvider>
      </ConfirmDialogProvider>
    </QueryClientProvider>
  )
}

export default LoggedIn
